import { t as uiText } from '../i18n';
import React from 'react';

interface FolderDeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  folderName: string;
  isDeleting: boolean;
}

const FolderDeleteConfirmModal: React.FC<FolderDeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  folderName,
  isDeleting
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        {/* ヘッダー */}
        <div style={{
          marginBottom: '20px'
        }}>
          <h3 style={{
            margin: 0,
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#333',
            marginBottom: '8px'
          }}>
            {uiText("Delete folder")}
          </h3>
        </div>

        {/* メッセージ */}
        <div style={{
          marginBottom: '24px',
          lineHeight: '1.6'
        }}>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#333',
            marginBottom: '12px'
          }}>
            <strong>「{folderName}」</strong>{uiText("delete this?")}
          </p>
          
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px'
          }}>
            <strong>「{folderName}」</strong>{uiText(": all folders inside will be deleted")}
          </p>
          
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#666'
          }}>
            <strong>「{folderName}」</strong>{uiText("and pages in folders inside it are not deleted. They are removed from the folder and appear only in All pages.")}
          </p>
        </div>

        {/* ボタン */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            disabled={isDeleting}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              color: '#666',
              fontSize: '14px',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              opacity: isDeleting ? 0.6 : 1,
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (!isDeleting) {
                e.currentTarget.style.backgroundColor = '#f5f5f5';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDeleting) {
                e.currentTarget.style.backgroundColor = 'white';
              }
            }}
          >
            {uiText("Cancel")}
          </button>
          
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: isDeleting ? '#ccc' : '#dc3545',
              color: 'white',
              fontSize: '14px',
              cursor: isDeleting ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              if (!isDeleting) {
                e.currentTarget.style.backgroundColor = '#c82333';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDeleting) {
                e.currentTarget.style.backgroundColor = '#dc3545';
              }
            }}
          >
            {isDeleting ? (
              <>
                <div style={{
                  width: '12px',
                  height: '12px',
                  border: '2px solid #fff',
                  borderTop: '2px solid transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
                {uiText("Deleting...")}
              </>
            ) : (
              uiText("Delete")
            )}
          </button>
        </div>

        {/* ローディングアニメーション用のCSS */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default FolderDeleteConfirmModal;
